import axios from "axios";

// .env
// REACT_APP_API_BASE_URL=https://implago-backend-zdlv.onrender.com
const baseURL = (process.env.REACT_APP_API_BASE_URL || "https://implago-backend-zdlv.onrender.com").replace(
  /\/+$/,
  ""
);

const axiosInstance = axios.create({
  baseURL,
  withCredentials: false,
  timeout: 30000,
});

// ✅ DRF Token: Authorization: Token <key>
// ✅ Tek doğru kaynak: localStorage "accessToken"
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    config.headers = config.headers || {};

    if (token) {
      config.headers.Authorization = `Token ${token}`;
    } else {
      delete config.headers.Authorization;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;